import { MetricsChart } from 'components/MetricsChart';
import { ChartDataArray } from 'components/chart/data/ChartDataArray';
import { ChartDataType } from 'components/chart/data/ChartDataType';
import { ChartData } from 'components/chart/data/ChartData';
import { BarChartConfig } from 'components/chart/data/BarChartConfig';
import { BarChartRenderer } from 'components/chart/renderer/BarChartRenderer';
import { useModelService } from 'services/model/model.service';
import { useIntl } from 'react-intl';
import { TileContent } from 'components/Layout/PageContainer';
import { getArrayWithIsOthers } from 'pages/insights-pro/common/graphs/getArrayWithIsOthers';
import { CategoryInfo, MarketplaceInfo } from '../model';

interface MarketplacesCategorySharesProps {
  categories: CategoryInfo[];
  marketplaces: MarketplaceInfo[];
}

export function MarketplacesCategoryShares({ categories, marketplaces }: MarketplacesCategorySharesProps) {
  const { getMeasureByMetric } = useModelService();

  const intl = useIntl();

  const ordGmvVal = getMeasureByMetric('ordGmvVal', 'OD');

  const createMarketplacesChartConfig = () => {
    const marketplacesChartConfig = new BarChartConfig();
    marketplacesChartConfig.breakdownMode = 'fill-stacked';
    marketplacesChartConfig.value = {
      code: ordGmvVal.code,
      label: ordGmvVal.metric.name,
      unit: ordGmvVal.metric.unit,
    };
    marketplacesChartConfig.legendConfig = {
      hide: false,
    };
    const reversedMarketplaces = marketplaces
      .sort((a, b) => b.totalGmv - a.totalGmv)
      .slice(0, 5)
      .reverse();
    marketplacesChartConfig.data = [
      new ChartDataArray(
        ChartDataType.primary,
        'all',
        reversedMarketplaces.map(marketplace => new ChartData(marketplace.name, marketplace.totalGmv))
      ),
      ...getArrayWithIsOthers(categories, [ordGmvVal.code], intl, c => c).map(category => {
        const array = new ChartDataArray(
          ChartDataType.breakdown,
          category.name,
          reversedMarketplaces.map(marketplace => {
            const marketplaceCategory = getArrayWithIsOthers(
              marketplace.categories,
              [ordGmvVal.code],
              intl,
              c => c
            ).find(mc => mc.name === category.name);
            return new ChartData(marketplace.name, ordGmvVal.getValue(marketplaceCategory?.entry.values));
          })
        );
        array.color = category.color;
        return array;
      }),
    ];

    return marketplacesChartConfig;
  };

  const marketplacesChartRenderer = new BarChartRenderer(createMarketplacesChartConfig());

  return (
    <TileContent className="px-0">
      <MetricsChart renderer={marketplacesChartRenderer} height="h-[400px]" />
    </TileContent>
  );
}
